import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Support from './pages/Support';
import 'bootstrap/dist/css/bootstrap.min.css';
import Privacy from './pages/Privacy';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' extact element={<Privacy />} />
        <Route path='/support' element={<Support />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
